import React, { useEffect, useState } from 'react';
import { useStore } from '../../store/store';
import './messages.css';
import closeIcon from '../../assets/svgs/close.svg';
import errorIcon from '../../assets/svgs/error.svg';
import InfoIcon from '../../assets/svgs/information.svg';
import notiIcon from '../../assets/svgs/notification.svg';
import warningIcon from '../../assets/svgs/warning.svg';
import successIcon from '../../assets/svgs/check.svg';
import { MessageI } from '../../interfaces/interfaces';
import { M_Success } from '../../common/Types';

const Messages = () => {
  const { isLoading, messages, removeMessage } = useStore();

  // on new messsage, render animation
  const [active, setActive] = useState(false);
  useEffect(() => {
    setActive(false);

    const _messageTOFunc = setTimeout(() => {
      setActive(true);
    }, 100);

    // remove success messages after 5sec
    const _removeMsgTOFunc = setTimeout(() => {
      messages.forEach((_m) => {
        if (_m.type === M_Success) {
          removeMessage(_m);
        }
      });
    }, 5000);

    return () => {
      clearTimeout(_removeMsgTOFunc);
      clearTimeout(_messageTOFunc);
    };
  }, [messages, removeMessage]);

  const renderMessageIcon = (_message: MessageI) => {
    type MessageIconsObjI = { [key: string]: string };

    const messageIconsObj: MessageIconsObjI = {
      close: closeIcon,
      error: errorIcon,
      notification: notiIcon,
      information: InfoIcon,
      warning: warningIcon,
      success: successIcon,
    };

    const errorType = _message.type.toLowerCase();

    const messageIcon: string = messageIconsObj[errorType];

    return (
      <img
        className={`type-icon`}
        src={messageIcon}
        alt={`${errorType} icon`}
      />
    );
  };

  if (isLoading) {
    return <></>;
  } else {
    return (
      <>
        {React.Children.toArray(
          messages
            // limit only first 3 message
            .slice(0, 3)
            .map((_m, mIndex) => (
              <div
                className={`message-box ${_m.type.toLowerCase()} ${
                  active ? 'active' : ''
                }`}
                style={{ opacity: `0.${9 - mIndex * 4}` }}
              >
                <p>
                  {renderMessageIcon(_m)}
                  <em>{_m.content}</em>
                  <img
                    className={`close-icon clickable`}
                    onClick={() => removeMessage(_m)}
                    src={closeIcon}
                    alt={`close message icon`}
                  />
                </p>
              </div>
            ))
        )}
      </>
    );
  }
};

export default Messages;
